import { CRUDEntity } from "../abstracts/CRUDEntity";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";

export class Note extends CRUDEntity{
    constructor(id=null){
        super();
        this.entityClass = 'note';
        this.urlRoot = /admin/.test(location.href.split(/[\\\/]+/).shift()) ? '/admin/notes/note' : '/notes/note';
        this.sectionRootUrl = /admin/.test(location.href.split(/[\\\/]+/).pop()) ? '/admin/notes' : '/admin/note';
        this.id = id;
        
        Object.assign(Note.prototype, HasAttachments);

        this.setAttachmentCallbackPreview();
        this.setAttachmentCallbackDelete()
    }
}